import { gql } from '@apollo/client'

export const GET_SERIES_NEWS = gql`
  query ListSeriesArticlesVideosFront($input: oListSeriesArticlesVideosFront) {
    listSeriesArticlesVideosFront(input: $input) {
      oArticles {
        nTotal
        aResults {
          _id
          oImg {
            sUrl
          }
          oSeo {
            sSlug
          }
          dPublishDisplayDate
          dPublishDate
          nDuration
          nViewCount
          sTitle
          sDescription
        }
      }
    }
  }
`
